import { ResponseError } from '@marketplace-web/shared/api-client'
import { updateVatNumberArgs } from 'types/api/arguments/update-vat-number-args'
import { updateVatNumberResponse } from 'types/api/arguments/update-vat-number-response'

import { api } from './api'

export const updateVatNumber = async ({ vatNumber, countryCode, userId }: updateVatNumberArgs) => {
  return api.put<updateVatNumberResponse, ResponseError>('/business_accounts/update_vat_number', {
    vat_number: vatNumber,
    country_code: countryCode,
    user_id: userId,
  })
}
